module.exports = __webpack_public_path__ + "img/gao10.0703f5b5.png";